<template>
    <div :class="['kiosk-message-item d-flex mb-3', message.sender === 'user' ? 'justify-content-end' : 'justify-content-start']">
      <div :class="['kiosk-message-content card', message.sender === 'user' ? 'bg-primary text-white kiosk-user-message' : 'bg-light kiosk-ai-message', message.isError ? 'bg-danger text-white kiosk-error-message' : '']" style="max-width: 75%; border-radius: 1.25rem;">
        <div class="card-body p-3">
          <p class="kiosk-message-text mb-1" v-html="formatMessage(message.text)"></p>
          <div v-if="message.sender === 'ai' && message.isLoading" class="kiosk-ai-typing-indicator my-2">
            <span class="kiosk-typing-dot">.</span><span class="kiosk-typing-dot">.</span><span class="kiosk-typing-dot">.</span>
          </div>
          <small class="kiosk-message-timestamp d-block text-right mt-1" :class="{'text-white-50': message.sender === 'user' && !message.isError, 'text-muted': message.sender === 'ai' && !message.isError }">{{ message.timestamp }}</small>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatMessage(text) {
            if (typeof text !== 'string') return '';
            const escapedText = text
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
            return escapedText.replace(/\n/g, '<br>');
        }
    }
}
</script>